import axios from 'axios'
import React from 'react'
import useBrowserStorage from './useBrowserStorage'
import { USER_GEOLOCATION_STORAGE_KEY } from '../constants'

type GeolocationState = {
  ip: string
  countryName: string
  countryCode: string
  city: string
  timezone: string
  currency: {
    locale: string
    currency: string
    currencySymbol?: string
  }
}

const useGeolocation = (): GeolocationState => {
  const [state, setState] = React.useState({
    ip: '',
    countryName: '',
    countryCode: '',
    city: '',
    timezone: '',
    currency: { locale: 'en-ZA', currency: 'ZAR', currencySymbol: 'R' }
  })

  const [locationData, setLocationData] = useBrowserStorage<GeolocationState>(
    USER_GEOLOCATION_STORAGE_KEY,
    'local'
  )

  const getGeoInfo = () => {
    if (!locationData) {
      axios
        .get('https://ipapi.co/json/')
        .then((response) => {
          const data = response.data
          const newState = {
            ...state,
            ip: data.ip,
            countryName: data.country_name,
            countryCode: data.country_calling_code,
            city: data.city,
            timezone: data.timezone
          }
          const stateFinal = {
            ...newState,
            currency:
              newState.countryCode === '+27'
                ? { locale: 'en-ZA', currency: 'ZAR', currencySymbol: 'R' }
                : { locale: 'en-US', currency: 'USD', currencySymbol: '$' }
          }

          setState(stateFinal)
          setLocationData(stateFinal)
        })
        .catch((error) => {
          console.log(error)
        })
    } else {
      setState({
        ...state,
        ip: locationData.ip || '',
        countryName: locationData.countryName || '',
        countryCode: locationData.countryCode || '',
        city: locationData.city || '',
        timezone: locationData.timezone || ''
      })
    }
  }
  React.useEffect(() => {
    getGeoInfo()
  }, [])
  return state
}

export default useGeolocation
